function ContactUs() {
  return <div className="terms-conditions contact-bock" data-sentry-component="ContactUs" data-sentry-source-file="index.jsx">
            <div className="container">
                <div className="terms-conditions-wrapper">
                    <div className="">
                        <h3>Contact Us</h3>
                        <div className="cus-row">
                            <div className="col-3">
                                <div className="contact-list">
                                    <h4>How to Contact Us?</h4>
                                    <p>If you have any question, please contact us:</p>
                                    <p>
                                        Email: <a href="mailto:contactus@chickinguae.com">contactus@chickinguae.com</a>
                                    </p>
                                    <p>
                                        Skype: <span>chickinguae</span>
                                    </p>
                                    <p>
                                        Telephone: <a href="tel:+97142594808">00971 4 2594808</a>
                                    </p>
                                    <p>
                                        Web:{' '}
                                        <a href="https://www.chickinguae.com" target="_blank" rel="noopener noreferrer">
                                            https://www.chickinguae.com
                                        </a>
                                    </p>
                                </div>
                            </div>
                            <div className="col-3">
                                <div className="contact-list contact-address">
                                    <h4>Contact Address:</h4>
                                    <p>
                                        #1106, ETA STAR, <br /> Al Manara Tower, <br /> PO Box: 87546, <br />
                                        Al Abraj Street, <br /> Business Bay, Za'abeel, Dubai, UAE.
                                    </p>
                                </div>
                            </div>
                            <div className="col-3">
                                <div className="contact-list contact-address">
                                    <h4>INDIA HEAD OFFICE</h4>
                                    <p>
                                        3rd Floor, Veerath Complex, Civil Line Rd, <br />
                                        Palarivattom, Ernakulam, Kerala 682025, India.
                                    </p>
                                    <p>
                                        <a href="tel:+914844058628">0484 4058628</a> <br />
                                        <a href="tel:+914842331166">0484 2331166</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>;
}
export default ContactUs;